import { render, staticRenderFns } from "./previewType.vue?vue&type=template&id=5b4aa436&scoped=true&"
import script from "./previewType.vue?vue&type=script&lang=js&"
export * from "./previewType.vue?vue&type=script&lang=js&"
import style0 from "./previewType.vue?vue&type=style&index=0&id=5b4aa436&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4aa436",
  null
  
)

export default component.exports